import React from 'react';
import { BsExclamationCircleFill } from 'react-icons/bs';

export enum stateNotificationsEnum {
	SUCCESS = 'Success',
	WARN = 'Warning',
	ERROR = 'Error'
}

type props = {
	message: string;
	type: string;
};

export default function Notification({ message, type }: props) {
	return (
		<div className="max-w-[300px] bg-gray-300 dark:bg-gray-600 rounded-lg border-gray-400 dark:border-gray-700  border p-3 shadow-lg cursor-pointer">
			<div className="flex flex-row">
				<div className="mx-auto flex-shrink-0 flex items-center justify-center mt-1 h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
					{type === stateNotificationsEnum.SUCCESS && (
						<BsExclamationCircleFill
							className="h-8 w-8 text-green-600"
							aria-hidden="true"
						/>
					)}
					{type === stateNotificationsEnum.WARN && (
						<BsExclamationCircleFill
							className="h-8 w-8 text-orange-500"
							aria-hidden="true"
						/>
					)}

					{type === stateNotificationsEnum.ERROR && (
						<BsExclamationCircleFill
							className="h-8 w-8 text-red-600"
							aria-hidden="true"
						/>
					)}
				</div>
				<div className="ml-2 mr-2">
					<h3 className="font-semibold text-gray-800 dark:text-gray-200">
						{type + '!'}
					</h3>
					<h3 className="block text-gray-800 dark:text-gray-200">{message}</h3>
				</div>
			</div>
		</div>
	);
}
